import React from 'react';
import { Tag, Button } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

const InitialCriteriaPanel = ({ searchData, onBackToSteps }) => {
  const { t } = useTranslation();

  if (!searchData || !searchData.selections) {
    return null;
  }

  const activeSelections = Object.entries(searchData.selections || {}).filter(
    ([field, values]) => values && values.length > 0
  );

  if (activeSelections.length === 0) {
    return null;
  }

  const getFieldLabel = (field) => {
    // Handle nested field names like "treatment_cultures.culture"
    const normalizedField = field.includes('.')
      ? field.split('.').pop()
      : field;

    switch (normalizedField) {
      case 'cultures':
      case 'culture':
        return t('treatment-search|filters.cultures');
      case 'cultural_practices':
        return t('treatment-search|filters.cultural_practices');
      case 'treatment_types':
      case 'treatment_type':
        return t('treatment-search|filters.treatment_types');
      case 'application_types':
      case 'application_type':
        return t('treatment-search|filters.application_types');
      case 'intervention_periods':
      case 'intervention_period':
        return t('treatment-search|filters.intervention_periods');
      default:
        return field.replace('_', ' ');
    }
  };

  return (
    <div className="filters-container">
      <Button
        type="text"
        size="small"
        icon={<ArrowLeftOutlined />}
        onClick={onBackToSteps}
        className="flex items-center gap-1 text-gray-600 hover:text-blue-600 px-2 py-1 h-auto"
      >
        {t('actions.back_to_search', 'Retour à la recherche')}
      </Button>
      <div className="flex items-center gap-2 mb-4 p-4 pb-2">
        <h4 className="normal-case text-lg sm:text-xl font-medium">
          {t('treatment-search|Résumé des critères de recherche')}
        </h4>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 px-4 pb-4">
        {activeSelections.map(([field, values]) => {
          const labels = searchData.selectionLabels?.[field] || [];
          return (
            <div key={field} className="space-y-2">
              <div className="font-medium text-gray-800">
                {getFieldLabel(field)}
              </div>
              <div className="flex flex-wrap gap-1">
                {labels.length > 0
                  ? labels.map((label, index) => (
                      <Tag key={index} className="mb-1">
                        {label.label || label.name || values[index]}
                      </Tag>
                    ))
                  : // Fallback: use the raw values if no labels available
                    values.map((value, index) => (
                      <Tag key={index} className="mb-1">
                        {value}
                      </Tag>
                    ))}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default InitialCriteriaPanel;
